import { RefObject } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

const useClickOutside = (ref: RefObject<any> | RefObject<any>[], callback: () => void) => {
  const handleClick = (e: MouseEvent) => {
    if (Array.isArray(ref)) {
      let isInside = false
      // Loop through ref to check if click is contained
      ref?.forEach(item => {
        if (item.current && item.current.contains(e.target)) {
          isInside = true
          // Break at the first contained click event
          return false
        }
      })
      if (isInside === false && callback) callback()
    } else if (ref.current && !ref.current.contains(e.target) && callback) callback()
  }

  useIsomorphicLayoutEffect(() => {
    document.addEventListener('click', handleClick)
    document.addEventListener('touchstart', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('touchstart', handleClick)
    }
  })
}

export default useClickOutside
